import React, { useState } from "react";
import Moment from "react-moment";

import { GrFormClose } from "react-icons/gr";
import { Modal } from "antd";

import { resolveCertificateComponent } from "../../Screens/Certificates/resolveCertificate";
import { downloadUploadedCertificate } from "../../utils/downloadUploadedCertificate";

import "./style.css";
import "../../App.css";

const VehicleCertificateTileComponent = ({ item }) => {
  const [company, setCompany] = useState(false);
  const [companyModalVisible, setCompanyModalVisible] = useState(false);
  const [iscertificateLoading, setisCertificateLoading] = useState(false);
  const [certificateData, setCertificateData] = useState({
    id: "",
    companyId: "",
    companyName: "",
    templateId: "",
    url: "",
  });

  const showCompanyModal = () => {
    // reset any previous selection so reopening starts fresh
    setCompany(false);
    setCertificateData({
      id: "",
      companyId: "",
      companyName: "",
      templateId: "",
      url: "",
    });
    setCompanyModalVisible(true);
  };

  const handleOkCompany = () => {
    setCompanyModalVisible(false);
  };
  const handleCancelCompany = () => {
    setCompanyModalVisible(false);
    setCompany(false);
    setCertificateData({
      id: "",
      companyId: "",
      companyName: "",
      templateId: "",
      url: "",
    });
  };

  const handleDownload = (items, id) => {
    setCompany(true);
    setCertificateData({
      id: id,
      companyId: items?.Company?.id,
      companyName: items?.Company?.name,
      templateId: items?.Company?.templateId,
      url: items?.certificateUrl,
    });
  };

  // After the user clicks the generated Download button, refresh the page so
  // the certificate modal closes automatically. Ignores clicks fired while the
  // PDF is still being prepared.
  const handleDownloadClickClose = (e) => {
    const btn = e.target.closest(".certificate-download-button");
    if (!btn || btn.classList.contains("is-loading")) return;
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  // Always renders the generated React-PDF certificate for the resolved
  // company/state template.
  const renderCertificate = () => {
    if (!company) return null;

    // Lyft (all states): if a certificate image was uploaded on the dashboard, download that
    // image instead of generating the PDF. Falls back to the PDF when no image was uploaded.
    if (
      certificateData?.companyName?.toLowerCase() === "lyft" &&
      certificateData?.url
    ) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="certificate-download-button"
            style={{ cursor: "pointer" }}
            onClick={() =>
              downloadUploadedCertificate(certificateData.url).then(() =>
                setTimeout(() => window.location.reload(), 1500)
              )
            }
          >
            Download vehicle report
          </div>
        </div>
      );
    }

    const CertificateComponent = resolveCertificateComponent(
      certificateData,
      item?.inspectionState
    );

    if (!CertificateComponent) return null;

    return (
      <div onClick={handleDownloadClickClose}>
        <CertificateComponent
          SetModal={setCompanyModalVisible}
          handleModal={handleCancelCompany}
          setLoading={setisCertificateLoading}
          isLoading={iscertificateLoading}
          companyId={certificateData?.companyId}
          id={certificateData?.id}
        />
      </div>
    );
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="certificates-tile">
        <div className="certificates-tile-content">
          <div>
            <div className="certificates-tracking-id-text">
              License Plate No.
            </div>
            <div className="certificates-tracking-id">
              {item?.Vehicle?.licensePlateNumber}
            </div>
          </div>
          <div>
            <div className="certificates-date-created">Date Created</div>
            <div className="certificates-date">
              <Moment format="MM/DD/YYYY">{item?.createdAt}</Moment>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            className="certificates-button"
            onClick={() => {
              showCompanyModal();
            }}
          >
            Download Certificate{" "}
          </button>
        </div>
        <Modal
          style={{ width: "40px", height: "40px" }}
          title="Basic Modal"
          visible={companyModalVisible}
          onOk={handleOkCompany}
          onCancel={() => {
            handleCancelCompany();
          }}
        >
          <div className="companies-modal">
            <div className="modal-content-container">
              <div></div>
              <div className="option-text">Companies</div>
              <GrFormClose
                color="black"
                size={25}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleCancelCompany();
                }}
              />
            </div>
            {item?.CompanyInspections?.map((items) => {
              return (
                <div
                  className="modal-company-text"
                  key={items?.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleDownload(items, item?.id);
                  }}
                >
                  <div className="modal-links-text">{items?.Company?.name}</div>
                  <input
                    className="checkbox-container"
                    type="radio"
                    name={`company-${item?.id}`}
                    style={{ cursor: "pointer" }}
                    checked={
                      company &&
                      certificateData?.companyId === items?.Company?.id
                    }
                    readOnly
                  />
                </div>
              );
            })}

            {renderCertificate()}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default VehicleCertificateTileComponent;
